import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { PaginatedPerfusionSetListFilters, PerfusionSetOrganType } from '@/api/apis/resources';
import { UseQueryConfig } from '@/api/types';
import { perfusionSetsQueryKeys } from '@/queries/perfusion-sets/perfusion-sets.keys';

const allPerfusionSetsPaginationParams: PaginatedPerfusionSetListFilters = {
  itemsPerPage: 100,
  pageIndex: 0,
};

export const perfusionSetQueries = {
  all: () =>
    queryOptions({
      queryKey: perfusionSetsQueryKeys.getList(allPerfusionSetsPaginationParams),
      queryFn: () => api.resource.getPerfusionSetsList(allPerfusionSetsPaginationParams),
    }),
  list: (filters: PaginatedPerfusionSetListFilters) =>
    queryOptions({
      queryKey: perfusionSetsQueryKeys.getList(filters),
      queryFn: () => api.resource.getPerfusionSetsList(filters),
      placeholderData: keepPreviousData,
    }),
};

const usePerfusionSetsListQuery = (filters: PaginatedPerfusionSetListFilters, options?: UseQueryConfig) => {
  const defaultFilter = [
    PerfusionSetOrganType.HeartPerfusionSet,
    PerfusionSetOrganType.LiverPerfusionSet,
    PerfusionSetOrganType.LungPerfusionSet,
    PerfusionSetOrganType.KidneyPerfusionSet,
  ].join(',') as unknown as PerfusionSetOrganType[]; // FIXME: Remove type assertion after API filters change
  const requestFilters = {
    ...filters,
    inventoryPartTypes: filters?.inventoryPartTypes?.length ? filters.inventoryPartTypes : defaultFilter,
  };
  return useQuery({
    ...perfusionSetQueries.list(requestFilters),
    ...options,
  });
};

export { usePerfusionSetsListQuery };
